import { render, staticRenderFns } from "./CopyrightPage.vue?vue&type=template&id=344ccfb4&scoped=true&"
import script from "./CopyrightPage.vue?vue&type=script&lang=js&"
export * from "./CopyrightPage.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightPage.vue?vue&type=style&index=0&id=344ccfb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344ccfb4",
  null
  
)

export default component.exports